import { BrowsingCriteria } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import apolloClient from 'api/apolloClient';
import { GET_ALLIED_AGENCIES, GET_ALLIED_AGENTS } from 'api/queries/idTrackerService';
import { Agent, AlliedAgency } from 'types/idTrackerService';

export async function getAlliedAgencies(bc: BrowsingCriteria[]): Promise<AlliedAgency[]> {
  return (
    await apolloClient.query<{ getAlliedAgencies: AlliedAgency[] }>({
      query: GET_ALLIED_AGENCIES,
      variables: { bc },
      fetchPolicy: 'no-cache',
    })
  ).data.getAlliedAgencies;
}

export async function getAlliedAgents(region: string, agencyId: string, tin: string): Promise<Agent[]> {
  return (
    await apolloClient.query<{ getAlliedAgents: Agent[] }>({
      query: GET_ALLIED_AGENTS,
      variables: { region, agencyId, tin },
      fetchPolicy: 'no-cache',
    })
  ).data.getAlliedAgents;
}
